import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import {
  LayoutDashboard,
  PawPrint,
  Stethoscope,
  Pill,
  Package,
  FlaskConical,
  ShieldAlert,
  Settings,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react'

const navItems = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/patients', label: 'Patients', icon: PawPrint },
  { to: '/treatments', label: 'Treatments', icon: Stethoscope },
  { to: '/prescriptions', label: 'Prescriptions', icon: Pill },
  { to: '/medications', label: 'Medications', icon: Package },
  { to: '/lab-work', label: 'Lab Work', icon: FlaskConical },
  { to: '/controlled-substances', label: 'Controlled Substances Log', icon: ShieldAlert },
  { to: '/settings', label: 'Settings', icon: Settings },
]

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <aside
      data-testid="sidebar"
      className="flex flex-col bg-sidebar h-screen sticky top-0 transition-all duration-200"
      style={{ width: collapsed ? '52px' : 'var(--spacing-sidebar-width)' }}
    >
      <div className="flex items-center justify-between px-3 h-12">
        {!collapsed && (
          <span className="text-sm font-semibold text-text-primary truncate">VetRx</span>
        )}
        <button
          data-testid="sidebar-toggle"
          onClick={() => setCollapsed(!collapsed)}
          className="flex items-center justify-center w-7 h-7 rounded hover:bg-hover text-text-muted"
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>
      <nav className="flex flex-col gap-0.5 px-2 flex-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`nav-${item.to.slice(1)}`}
            title={collapsed ? item.label : undefined}
            className={({ isActive }) =>
              `flex items-center gap-2 rounded h-7 text-[13px] font-[450] transition-colors duration-100 ${
                collapsed ? 'justify-center px-0' : 'px-2'
              } ${
                isActive
                  ? 'bg-nav-active text-text-primary font-medium'
                  : 'text-text-secondary hover:bg-hover'
              }`
            }
          >
            <item.icon size={16} className="flex-shrink-0" />
            {!collapsed && <span className="truncate">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
